<template>
<div class="col-lg-12">
  <div class="container">
    <div id="NotFound">
      <div class="container">
        <div class="row" style="justify-content:center;">
          <div class="col-lg-12 not-found mb-5">
            <img src="/static/images/404.png" class=""/>
            <h2>Parece que te perdiste.</h2>
            <b-link  to="/home" class="return"> <i class="fa fa-arrow-circle-left"></i> Regresar al Inicio</b-link>
            <div class="divider-01"/>
            <p>También te puede interesar...</p>
          </div>
          
        </div>
        
        <VueSlickCarousel  v-if="articulos.length >0" v-bind="settings" class="col-lg-10" style="margin-right:auto;margin-left:auto;">
          <div v-for="articulo in articulos" :value="articulo.value" :key="articulo.value" class="col-lg-12 article">
            <b-link :to="'blog/articulo/' +  articulo.id">
              <div>
                <img :src="url + articulo.imagen">
                <p>{{articulo.titulo}}</p>
                <b-link :to="'blog/articulo/' +  articulo.id">Leer más <b-icon icon="chevron-right" class="ml-2 chevron"></b-icon></b-link>
              </div> 
            </b-link>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import env from '@/plugins/enviroment';
import postsApi from "../api/posts";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  data() {
    return {
      articulos:[],
      settings:{
  "dots": true,
  "infinite": false,
  "speed": 500,
  "slidesToShow": 3,
  "slidesToScroll": 3,
  "initialSlide": 0,
  "responsive": [
    {
      "breakpoint": 1024,
      "settings": {
        "slidesToShow": 3,
        "slidesToScroll": 3,
        "infinite": true,
        "dots": true
      }
    },
    {
      "breakpoint": 600,
      "settings": {
        "slidesToShow": 2,
        "slidesToScroll": 2,
        "initialSlide": 2
      }
    },
    {
      "breakpoint": 480,
      "settings": {
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "infinite":false,
        "dots":false
      }
    }
  ]
},
    
      urlImg:""
    }
  },
  components: {
    VueSlickCarousel,
  },
  methods: {
    isMobile() {
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    getPosts(){
      /*
      -PARAMETROS PERMITIDOS-
        categoria_id=1
        titulo=conta
        tipo=posts
        fecha_publicacion=2020-10-02
        min_fecha_publicacion=2020-10-02
        max_fecha_publicacion=2020-10-03
        activo=true
        paginate=true
        items_to_show=10
        order=asc
        order_by=fecha_publicacion
        -------------------------*/

      let parametros = {activo: true,paginate:true,items_to_show:3,order:"asc",order_by:"fecha_publicacion"};
      postsApi
      .getPosts(parametros)
      .then(response => {

        this.articulos = response.data.data;
        
      }).catch(err => {
        console.log("Ocurrio un error al cargar los articulos.");
      });
    }
  },mounted () {
      this.getPosts();
    },
  created () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    this.url = env.baseURL;
  },
}
</script>

<style scoped>

.return{
  color:#2DB9D1;
  font-family: Muli;
  font-weight: bolder;
  font-size: 30px;
}

  .divider-01 {
    height: 5px;
    width: 16%;
    background-color: #E8404E;
    border-radius: 3px;
    margin: 20px auto 70px auto;
    
  }

  .not-found img{
    width: 60%;
    }

  .not-found p{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    display: flex;
    line-height: 140.62%;
    text-align: center;
    color: #1E2245;
  }

  .not-found h2{
    font-family: Muli;
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 65px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #BDBDBD;
    padding-top:20px;
  }

  .article{
    margin-bottom:auto;
    text-align: left;
  }
  .article > a{
    text-decoration: none;
  }
  .article  div{
    margin:0px 0px 10px 0px;
    padding-bottom:15px;
    transition: 0.3s;
  }
  .article:hover  div{
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  }
  .article img {
    width: 100%;
    height: 29vh;
    border-radius: 10px;
  }

  .article p {
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 25px;
    color: #1E2245;
    padding:15px;
    height: 140px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 10px;
  }

  .article a{
    padding-left:15px ;
    margin-top:-20px;
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #1E2245;
  }


  @media(max-width: 768px){
    .article img {
      height: 35vh;
    }
  }  

  @media(max-width: 768px){
  .not-found img{
    width: 100%;
    }
    
  }

</style>
